// import { useAuthState } from "react-firebase-hooks/auth";
import { useRouter } from "next/router";
import { useJoin } from "lib/new-auth";
import { useCurrentViewer } from "state/auth";
import { setCurrentConference } from "state/conference";
import { LoadingScreen } from "components/micro-interaction/loader";
import { useEffect, useState } from "react";

/**
 * ページ本体
 *
 * ログアウト状態であればURLパラメタの会議にログイン
 *
 * ログイン状態で、URLパラメタの会議とログインしている会議が同じであれば
 * ログイン中の会議にリダイレクト
 *
 * ログイン状態で、URLパラメタの会議とログインしている会議が違う場合は
 * URLパラメタの会議にログイン
 *
 * TODO: ログイン状態で、URLパラメタの会議とログインしている会議が同じで
 * ログイン中の会議が強制退出実行後の場合、一度ログアウトし、
 * 新しいユーザーとしてログイン
 *
 */
export default function Join() {
  const router = useRouter();
  const { conferenceId, speakerSession, s } = router.query;
  const { loading, currentViewer, auth } = useCurrentViewer();
  const {
    loading: loadingCurrentConference,
    currentConference,
  } = setCurrentConference(`${conferenceId}`);
  const { joinProcessState, join, migrate } = useJoin();
  const [reload, setReload] = useState(false);
  useEffect(() => {
    // 40秒経過して進展なければ一度リロード
    setTimeout(() => setReload(true), 1000 * 40);
  }, []);

  if (reload) {
    router.reload();
    return (
      <LoadingScreen text="画面をリロードします。そのままおまちください" />
    );
  }
  if (loading || loadingCurrentConference) {
    return <LoadingScreen />;
  }
  if (currentConference.signInProvider === "EMAIL_AND_PASSWORD") {
    router.push(`/conferences/${conferenceId}/login`);
    return <div></div>;
  }
  if (currentConference.signInProvider === "CLUB") {
    router.push(`/conferences/${conferenceId}/connect`);
    return <div></div>;
  }
  // if (error) {
  //   if (error instanceof InternalServerError) {
  //     return <div>ログイン中にエラーが発生しました。</div>;
  //   } else if (error instanceof TooManyRequestError) {
  //     return <div>アクセスが集中しています。</div>;
  //   } else {
  //     return <div>エラーが発生しました</div>;
  //   }
  // }
  if (!currentViewer) {
    if (joinProcessState === "IDLE") {
      join(`${conferenceId}`, { streamSessionId: `${speakerSession ?? ""}`, s: `${s ?? ""}` });
    }
    return (
      <LoadingScreen
        text="データ取得中です。少々お待ちください。"
        secondaryText={{
          wait: 10000,
          text:
            "データ取得に少し時間がかかっています。\nこのままもうしばらくおまちください。",
        }}
      />
    );
  } else if (currentViewer.participatingConference.id !== conferenceId) {
    if (joinProcessState === "IDLE") {
      migrate(auth, `${conferenceId}`, {
        streamSessionId: `${speakerSession ?? ""}`,
      });
    }
    return (
      <LoadingScreen
        text="データ取得中です。少々お待ちください。"
        secondaryText={{
          wait: 10000,
          text:
            "データ取得に少し時間がかかっています。\nこのままもうしばらくおまちください。",
        }}
      />
    );
  }
  router.push(`/conferences/${conferenceId}/live`);
  return <div></div>;
}
